import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { stepToUrl } from '../../../shared/onboardingUtils';
import { routesConfig } from '../../../shared/onboardingConfig';
import { REGISTRATION_FLOW } from '../../../shared/onboardingConstants';

import { useOnboardingContext } from '../../../state/OnboardingContext';

import CreateProfile from '../../steps/registration/CreateProfile';
import SuggestedFriends from '../../steps/registration/SuggestedFriends';
import FacebookFriends from '../../steps/registration/FacebookFriends';
import Welcome from '../../steps/registration/Welcome';
import SubscriptionTrial from '../../steps/registration/SubscriptionTrial/SubscriptionTrial';
import DirectPromotion from '../../steps/shared/DirectPromotion';

const RegistrationFlowRoutes = () => {
  const { state } = useOnboardingContext();
  const { category } = state;

  return (
    <Switch>
      <Route
        path={stepToUrl({ category, step: REGISTRATION_FLOW.createProfile })}
        {...routesConfig}
      >
        <CreateProfile />
      </Route>

      <Route
        path={stepToUrl({ category, step: REGISTRATION_FLOW.suggestedFriends })}
        {...routesConfig}
      >
        <SuggestedFriends />
      </Route>

      <Route
        path={stepToUrl({ category, step: REGISTRATION_FLOW.facebookFriends })}
        {...routesConfig}
      >
        <FacebookFriends />
      </Route>

      <Route
        path={stepToUrl({
          category,
          step: REGISTRATION_FLOW.subscriptionTrial
        })}
        {...routesConfig}
      >
        <SubscriptionTrial />
      </Route>

      <Route
        path={stepToUrl({
          category,
          step: REGISTRATION_FLOW.directPromotion
        })}
        {...routesConfig}
      >
        <DirectPromotion />
      </Route>

      <Route
        path={stepToUrl({ category, step: REGISTRATION_FLOW.welcome })}
        {...routesConfig}
      >
        <Welcome />
      </Route>
    </Switch>
  );
};

export default RegistrationFlowRoutes;
